import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzOffer180 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_80: Record<
  Exclude<PageIdWoofzOffer180, PageIdWoofzOffer180.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzOffer180.SUBSCRIPTIONS_OFFER1_80]: {
    id: PageIdWoofzOffer180.SUBSCRIPTIONS_OFFER1_80,
    hasHeader: false,
  },
  [PageIdWoofzOffer180.CHAT_UPSELL_OFFER1_80]: {
    id: PageIdWoofzOffer180.CHAT_UPSELL_OFFER1_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer180.UPSELL_OFFER1_80]: {
    id: PageIdWoofzOffer180.UPSELL_OFFER1_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer180.DOWNLOAD_OFFER1_80]: {
    id: PageIdWoofzOffer180.DOWNLOAD_OFFER1_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
